import {
  executeZsl,
  executeZslBodySchema,
  executeZslResponseSchema,
} from "./execute";

const ZslApi = {
  executeZsl,
  executeZslBodySchema,
  executeZslResponseSchema,
};

export { ZslApi };
